import cloneDeep from 'lodash/cloneDeep';
import formatIsoDate from '@/services/general/formatIsoDate';

function prepareEcheancierPaiement(facture) {
  const echeanciers = cloneDeep(facture.echeancierPaiement);
  const payeur = facture.intervenants.find((intervenant) => {
    return intervenant.payeur;
  });
  echeanciers.forEach((echeance) => {
    echeance.tiersId = payeur.tiersId;
    echeance.factureId = facture.id;
    echeance.dateEcheance = formatIsoDate(echeance.dateEcheance);
  });
  return echeanciers;
}

export default function prepareFactureAchatAlreadyPayeOrSave(facture, rapprochements) {
  const echeanciers = prepareEcheancierPaiement(facture);
  const copieFactureAchat = cloneDeep(facture);
  copieFactureAchat.rapprochements = rapprochements;
  const paramsToSave = ['id', 'lignesCommande', 'rapprochements'];
  const paramsToSaveLignesCommande = [
    'id', 'type', 'produitId', 'referenceRegroupement', 'lignesCommande',
  ];
  Object.keys(copieFactureAchat).forEach((key) => {
    if (!paramsToSave.includes(key)) delete copieFactureAchat[key];
  });
  copieFactureAchat.lignesCommande.forEach((ligne) => {
    ligne.lignesCommande.forEach((ligneEnfant) => {
      Object.keys(ligneEnfant).forEach((key) => {
        if (!paramsToSaveLignesCommande.includes(key)) delete ligneEnfant[key];
      });
    });
    Object.keys(ligne).forEach((key) => {
      if (!paramsToSaveLignesCommande.includes(key)) delete ligne[key];
    });
  });
  return { factureModifiee: copieFactureAchat, echeanciers: echeanciers };
}
